import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ControlComponent } from './control.component';
import { ActivityChartModule } from "./activity-chart/activity-chart.module";
import { ControlSelectorsComponent } from "./control-selectors/control-selectors.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {ScheduleService} from "../../services/vpp/schedule.service";
import {CalibrantLoadModule} from "../shared/calibrant-load/calibrant-load.module";
import {MaxRangeDirective} from "./control-selectors/max-range.directive";
import {NgSelectModule} from "@ng-select/ng-select";
import { MatOptgroup, MatOption, MatSelect } from '@angular/material/select';
import { MatChip, MatChipGrid, MatChipInput, MatChipRemove, MatChipRow } from '@angular/material/chips';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ActivityChartModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    CalibrantLoadModule,
    NgSelectModule,
    MatSelect,
    MatOption,
    MatChip,
    MatChipGrid,
    MatChipRemove,
    MatChipRow,
    MatAutocompleteTrigger,
    MatChipInput,
    MatAutocomplete,
    MatOptgroup,
    MatInput,
  ],
  declarations: [
    ControlComponent,
    ControlSelectorsComponent,
    MaxRangeDirective
  ],
  exports: [
    ControlComponent
  ],
  providers: [
    ScheduleService
  ],

})
export class ControlModule { }
